import { SubmenuDivHandler } from './SubmenuDivHandler.js';
import { EventsClient } from '../events-client.js';
import { MenuController } from './menu-controller.js';
import { getAvatarCatalog } from '../avatar/avatar-catalog.js';

const MM_AVATAR_HTML = `
        <div id="menu-modal-avatar" class="menu-modal-content">
            <h2>Avatar</h2>
            <p>Preview and select your avatar model</p>
            <div class="mm-avatar-status" id="mm-avatar-name">-</div>
            <div class="mm-avatar-status" id="mm-avatar-active">Active: -</div>
            <div class="mm-avatar-button-row">
                <button id="mm-avatar-prev" class="mm-submit-button">Previous</button>
                <button id="mm-avatar-next" class="mm-submit-button">Next</button>
            </div>
            <div class="mm-avatar-button-row">
                <button id="mm-avatar-select" class="mm-submit-button">Select Avatar</button>
            </div>
        </div>
`;

export class AvatarSubmenuDH extends SubmenuDivHandler {
    static TypeName = 'AvatarSubmenuDH';

    private index = 0;

    private get catalog() {
        return getAvatarCatalog();
    }

    private updateText(): void {
        const nameEl = document.getElementById('mm-avatar-name');
        const activeEl = document.getElementById('mm-avatar-active');
        const item = this.catalog[this.index];
        const activeId = EventsClient.instance?.getSelectedAvatarId?.() ?? 'default_sim';
        const active = this.catalog.find((entry) => entry.id === activeId);

        if (nameEl) {
            nameEl.textContent = item ? `Preview: ${item.label} (${item.id})` : 'No avatars configured';
        }

        if (activeEl) {
            activeEl.textContent = active ? `Active: ${active.label} (${active.id})` : `Active: ${activeId}`;
        }
    }

    private clampIndex(): void {
        const len = this.catalog.length;
        if (len <= 0) {
            this.index = 0;
            return;
        }
        if (this.index < 0) {
            this.index = len - 1;
            return;
        }
        if (this.index >= len) {
            this.index = 0;
        }
    }

    private previewCurrent(): void {
        const item = this.catalog[this.index];
        if (!item) {
            return;
        }

        MenuController.instance.showAvatarPreview(item.id);
        this.updateText();
    }

    updateConditionals(): void {
        this.clampIndex();
        this.updateText();
    }

    displayMenuContent(containerDiv: HTMLDivElement): void {
        containerDiv.innerHTML = MM_AVATAR_HTML;

        const list = this.catalog;
        const currentId = EventsClient.instance?.getSelectedAvatarId?.() ?? 'default_sim';
        const selectedIndex = list.findIndex((entry) => entry.id === currentId);
        this.index = selectedIndex >= 0 ? selectedIndex : 0;

        const btnPrev = document.getElementById('mm-avatar-prev') as HTMLButtonElement | null;
        const btnNext = document.getElementById('mm-avatar-next') as HTMLButtonElement | null;
        const btnSelect = document.getElementById('mm-avatar-select') as HTMLButtonElement | null;

        btnPrev?.addEventListener('click', () => {
            this.index -= 1;
            this.clampIndex();
            this.previewCurrent();
        });

        btnNext?.addEventListener('click', () => {
            this.index += 1;
            this.clampIndex();
            this.previewCurrent();
        });

        btnSelect?.addEventListener('click', () => {
            const item = this.catalog[this.index];
            if (!item) {
                return;
            }
            EventsClient.instance?.applyAvatarState?.({ avatarId: item.id });
            EventsClient.instance?.requestAvatarSelection(item.id);
            this.updateText();
        });

        this.previewCurrent();
    }

    hideContent(): void {
        MenuController.instance.clearAvatarPreview();
    }
}
